import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const updateCheckoutDetails = createAsyncThunk('updateCheckoutDetails/updateCheckoutDetails', async (data) => {
    const { name,city, company_name, address, gst } = data;
    try {
        const res = await axios({
            method: 'put',
            url: process.env.REACT_APP_API_URL + `update_profile_addressGst`,
            data: {
                name: name,
                city: city,
                company_name: company_name,
                address: address,
                gstnumber: gst,
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }
        })
        return res
    } catch (error) {
        return error.response
    }
})

